import React from 'react';

function Icon() {
  return (
    <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#BABFC8"
        fillRule="evenodd"
        d="M7.486.213a.727.727 0 011.241.514v9.091l1.68-1.603a.727.727 0 111.004 1.047L8.5 12.047a.727.727 0 01-1.003 0L4.59 9.262a.727.727 0 111.004-1.047l1.68 1.603V.728c0-.194.076-.379.213-.515zM.213 10.395a.727.727 0 011.242.514v2.182a1.454 1.454 0 001.454 1.455h10.182a1.454 1.454 0 001.455-1.455v-2.182a.728.728 0 111.454 0v2.182A2.909 2.909 0 0113.09 16H2.91A2.909 2.909 0 010 13.09v-2.18c0-.194.077-.379.213-.515z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export default Icon;
